import { Link, Outlet, useNavigate } from "react-router-dom";
import {
  Typography,
  Container,
  TextField,
  Switch,
  InputAdornment,
  InputLabel,
  FormControl,
  OutlinedInput,
  IconButton,
  Box,
  Toolbar,
  AppBar,
  Tabs,
  Tab,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import location from "../../assets/images/location.svg";
import calender1 from "../../assets/images/calender1.svg";
import carpark from "../../assets/images/car-parking.svg";
import { FaCalendarAlt, FaParking, FaCreditCard, FaPencilAlt, FaTrash, FaPhoneAlt } from "react-icons/fa";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BsHouseDoor, BsClockHistory, BsPerson, BsHeadset, BsChatDots, BsPenFill } from "react-icons/bs";
import { Button, ButtonGroup, Card, Col, Form, Modal, Row } from "react-bootstrap";
import WebService from "../../Services/WebService";

const Myvehicles = () => {
  const [phone, setPhone] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const Navigate= useNavigate()

  const [show, setShow] = useState(false);
  const [VehicleListData, setVehicleListData] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getVehicleList();
  }, []);

  const getVehicleList = () => {
    WebService.getAPI({
      action: `/api/Vehicle/List`,
    })
      .then((res: any) => {
        setVehicleListData(res);
      })
      .catch(() => {});
  };


  const HandleVehicleEdit=(res:any)=>{
    Navigate(`/addvehicles?id=${res.VehicleID}`)
  }



  return (
    <>
      <Container>
        <div className="app-container">
          {/* Sticky Header */}
          <header className="header text-white text-center d-flex justify-content-between align-items-center">
            <Link to="/profile">
              <button className="back-button backbutton">
                <IoIosArrowRoundBack size={30} color="white" />
              </button>
            </Link>
            <div>My Vehicles</div>
            <div className=" visablityhidden">
              <button className="back-button">&nbsp;&nbsp;&nbsp;&nbsp;</button>{" "}
            </div>
          </header>
          <Container className=" px-3 pagewrap">
            <div style={{ maxHeight: "90%", overflowY: "auto" }}>
              {VehicleListData &&
                VehicleListData.length > 0 &&
                VehicleListData.map((res: any, index: any) => {
                  return (
                    <>
                      <Card className="shadow-sm p-1 rounded border-0 parkdetails mb-4" key={index}>
                        <Card.Body>
                          <h5 className="fw-bold mb-3">Vehicle {index + 1}</h5>
                          <Row>
                            <hr />
                          </Row>
                          <Row className="mt-0">
                            <Col xs={6} className="mb-3">
                              <p className="text-muted mb-1">Vehicle Make</p>
                              <h6 className="fw-bold">{res.VehicleMake}</h6>
                            </Col>
                            <Col xs={6} className="mb-3">
                              <p className="text-muted mb-1">Model</p>
                              <h6 className="fw-bold">{res.VehicleModel}</h6>
                            </Col>
                            <Col xs={6} className="mb-0">
                              <p className="text-muted mb-1">Vehicle Plate #</p>
                              <h6 className="fw-bold">{res.PlateNumber}</h6>
                            </Col>
                            <Col xs={4} className="mb-0">
                              <p className="text-muted mb-1">State</p>
                              <h6 className="fw-bold">{res.PlateState}</h6>
                            </Col>
                            <Col xs={2} className="mt-3" style={{cursor:"pointer"}} onClick={()=>HandleVehicleEdit(res)}>
                              <BsPenFill />
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    </>
                  );
                })}
            </div>
            <div className="mb-3 mt-2">
              <Link to="/addvehicles">
                {" "}
                <Button className="btn btn-brand-1 w-100 font-bold" style={{ textTransform: "none" }}>
                  + Add Vehicle
                </Button>
              </Link>
            </div>
          </Container>
        </div>
      </Container>
    </>
  );
};

export default Myvehicles;
